import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../axios";
import { TbUsers } from "react-icons/tb";
import { RiShieldUserLine, RiCustomerService2Line } from "react-icons/ri";

import styles from "./Dashboard.module.css";

class Dashboard extends Component {
  state = {
    stats: "",
  };

  componentDidMount() {
    this.fetchStats();
  }

  fetchStats = () => {
    axios.get("/stats/dashboard").then((response) => {
      this.setState({
        stats: response.data,
      });
    });
  };

  render() {
    const { stats } = this.state;

    return (
      <div className={styles.Dashboard}>
        <div className={["PageContent", styles.PageContent].join(" ")}>
          <div className={styles.Cards}>
            <div className={styles.Card}>
              <div className={styles.Icon}>
                <TbUsers />
              </div>
              <div className={styles.Stat}>
                <Link to="/users">
                  <div className={styles.Count}>{stats.total_users}</div>
                  <div className={styles.Title}>Users</div>
                </Link>
              </div>
            </div>

            <div className={styles.Card}>
              <div className={styles.Icon}>
                <RiCustomerService2Line />
              </div>
              <div className={styles.Stat}>
                <Link to="/tickets">
                  <div className={styles.Count}>{stats.open_tickets}</div>
                  <div className={styles.Title}>Open Tickets</div>
                </Link>
              </div>
            </div>

            <div className={styles.Card}>
              <div className={styles.Icon}>
                <RiCustomerService2Line />
              </div>
              <div className={styles.Stat}>
                <Link to="/tickets">
                  <div className={styles.Count}>{stats.in_process_tickets}</div>
                  <div className={styles.Title}>In Process Tickets</div>
                </Link>
              </div>
            </div>

            <div className={styles.Card}>
              <div className={styles.Icon}>
                <RiShieldUserLine />
              </div>
              <div className={styles.Stat}>
                <Link to="/admins">
                  <div className={styles.Count}>{stats.total_admins}</div>
                  <div className={styles.Title}>Admins</div>
                </Link>
              </div>
            </div>

            <div className={styles.Card}>
              <div className={styles.Icon}>
                <RiShieldUserLine />
              </div>
              <div className={styles.Stat}>
                <Link to="/call-requests">
                  <div className={styles.Count}>
                    {stats.pending_call_requests}
                  </div>
                  <div className={styles.Title}>Pending Call Requests</div>
                </Link>
              </div>
            </div>

            <div className={styles.Card}>
              <div className={styles.Icon}>
                <RiShieldUserLine />
              </div>
              <div className={styles.Stat}>
                <Link to="/statement-requests">
                  <div className={styles.Count}>
                    {stats.pending_statement_requests}
                  </div>
                  <div className={styles.Title}>Pending Statement Requests</div>
                </Link>
              </div>
            </div>

            <div className={styles.Card}>
              <div className={styles.Icon}>
                <RiShieldUserLine />
              </div>
              <div className={styles.Stat}>
                <Link to="/offers-interests">
                  <div className={styles.Count}>
                    {stats.pending_offer_interests}
                  </div>
                  <div className={styles.Title}>Pending Offers Interests</div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Dashboard;
